import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-customer-apk',
  templateUrl: './modify-customer-apk.component.html',
  styleUrls: ['./modify-customer-apk.component.css']
})
export class ModifyCustomerAPKComponent implements OnInit {

  objectForm: any | FormGroup;
  allCustomer: any= []
  singleAPK: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  CustomerAPKid:any=""


  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllCustomerAPK()
    this.objectForm = this.fb.group({
      description:[''],
      keyValueList:this.fb.array([])
    }) 
    this.addkeyValue()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllCustomerAPK();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllCustomerAPK();
  }

  get objectArr(){
    return this.objectForm.get('keyValueList') as FormArray;
  }

  keyValueList(){
    return this.fb.group({
      "key": [''],
      "value": ['']
    })
  }
  
  addkeyValue(){
  this.objectArr.push(this.keyValueList())
  }

  removekeyValue(index: number){
  this.objectArr.removeAt(index)
  }

  updateCustomerAPK(){
    let body = 
    {
      "version": 0,
      "isActive": true,
      "description": String(this.objectForm.get('description').value),
      "id": this.CustomerAPKid,
      "keyValueList": this.objectForm.get('keyValueList').value,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateCustomerAPK(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.objectForm.reset()
        this.getAllCustomerAPK()
        this.toastr.success("Successfully Updated")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error.error.errors[0].description)
      }
    )
  }

  getAllCustomerAPK(){
    this.generic_service.getAllCustomerAPK().subscribe(
      (response:any)=>{
        console.log(response)
        this.allCustomer = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getCustomerAPKById(id:any){
    this.CustomerAPKid = id
    this.objectForm.reset()
    this.objectArr.clear()

    this.generic_service.getCustomerAPKById(id).subscribe(
      (response:any)=>{
        console.log(response)
        // this.singleAPK = []
        // this.singleAPK.push(response.response);
        this.objectForm.patchValue({
          description: response.response.description,
        })
        for(var i=0; i<response.response.keyValueList.length; i++){
          let obj = this.fb.group({
            "key":[response.response.keyValueList[i].key],
            "value":[response.response.keyValueList[i].value]
          })
          this.objectArr.push(obj)
        }
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }



}
